
import Empresa  from "../views/modulos/empresa/miempresa/FormEmpresa.vue";
import Empleado from "../views/modulos/empresa/empleados/List.vue";
import NotificacionUsuario from "../views/modulos/empresa/empleados/notificaciones/Form.vue";
import EmpleadoH from "../views/modulos/empresa/empleadosHotel/List.vue";
import RootEmpresa from "../views/modulos/root/empresa/List.vue";
import RootSucursal from "../views/modulos/root/sucursal/List.vue";
import TimbradoRutaBase from "../views/modulos/root/timbradoRutaBase/List.vue";
import TimbresHistorial from "../views/modulos/root/timbradoHistorial/List.vue";
import RootModulosSistema from "../views/modulos/root/modulossistema/List.vue";
import RootModulosSistemaForm from "../views/modulos/root/modulossistema/Form.vue";
import RootPaquetesSistema from "../views/modulos/root/paquetessistema/List.vue";
import RootPaquetesSistemaForm from "../views/modulos/root/paquetessistema/Form.vue";
import RootPaquetesSistemaEmpresa from "../views/modulos/root/paquetessistemaempresa/List.vue";
import RootModulosPaqueteEmpresa from "../views/modulos/root/modulos/List.vue";

const VarRutasEmpresa = [
    {
        path: "/FormularioEmpresa",
        name: "empresa",
        component: Empresa,
        props: true,
    }, {
        path:'/Empleados',
        name: 'empleados',
        component: Empleado,
        props: true, 
    }, {
        path:'/EmpleadosHoteles',
        name: 'empleadosB',
        component: EmpleadoH,
        props: true, 
    }, {
        path:'/CuentaEmpresa',
        name: 'cuentaEmpresa',
        component: RootEmpresa,
        props: true, 
    }, {
        path:'/CuentaSucursal',
        name: 'cuentaSucursal',
        component: RootSucursal,
        props: true, 
    }, {
        path:'/RutaDeTimbrado',
        name: 'timbradoRutaBase',
        component: TimbradoRutaBase,
        props: true, 
    }, {
        path:'/TimbresSucursal',
        name: 'timbresHistorial',
        component: TimbresHistorial,
        props: true,
    }, {
        path:'/ModulosSistema',
        name: 'modulosSistema',
        component: RootModulosSistema,
        props: true, 
    }, {
        path:'/ModulosSistemaForm',
        name: 'modulosSistemaForm',
        component: RootModulosSistemaForm,
        props: true, 
    }, {
        path:'/PaquetesSistema',
        name: 'paquetesSistema',
        component: RootPaquetesSistema,
        props: true, 
    }, {
        path:'/PaquetesSistemaForm',
        name: 'paquetesSistemaForm',
        component: RootPaquetesSistemaForm,
        props: true, 
    }, {
        path:'/PaquetesSistemaEmpresa',
        name: 'paquetesSistemaEmpresa',
        component: RootPaquetesSistemaEmpresa,
        props: true,
    }, {
        path:'/ModulosPaqueteEmpresa',
        name: 'modulosPaqueteEmpresa',
        component: RootModulosPaqueteEmpresa,
        props: true,
    }, {
        path:'/AsignarNotificacion',
        name: 'asignarNotificaciones',
        component: NotificacionUsuario,
        props: true, 
    },
];

export default {
	VarRutasEmpresa,
};
